import React from 'react';
import type { CheckboxOptionType } from 'antd/lib/checkbox/Group';
import ControlledRadioButtons from 'components/common/form-controlled/controlled-radio-buttons';
import type { UseFormReturnType } from 'hooks/use-form.hook';
import type { VcsModalFormValues } from './access-card/use-connection-modal-access-card-form.hook';

export type BlockRadioButtonProps = {
  options: Array<CheckboxOptionType | string | number>;
  form: UseFormReturnType<VcsModalFormValues>;
};

export const VcsConnectionModalFormAuthenticationTypeButton = ({ options, form }: BlockRadioButtonProps) => (
  <div>
    <ControlledRadioButtons
      label={{ id: 'templates.add.new.field.authorize.type' }}
      name={'authenticationType'}
      form={form}
      block
      options={options}
      optionType={'button'}
      buttonStyle={'solid'}
    />
  </div>
);
